/**
 * @param {Date} date
 * @returns the month in spanish
 */
export function getSpanishMonth(date) {
  const spanishMonth = date.toLocaleDateString("es-ES", { month: "long" });
  return spanishMonth.charAt(0).toUpperCase() + spanishMonth.slice(1);
}
